import React from 'react';
import VehicleUI from './components/VehicleUI';
import './App.css';

function App() {
  return (
    <div className="App">
      <main>
        <VehicleUI />
      </main>
    </div>
  );
}

export default App;
